$(document).ready(function(){

	// -- Init --
	var $grid = $('.grid').isotope({
	  itemSelector: '.grid__item',
		layoutMode: 'fitRows',
		filter: '*:not(.noResults)',
    hiddenStyle: {
      opacity: 0
    },
    visibleStyle: {
      opacity: 1
    }
	});
	$grid.imagesLoaded().progress(function() {
	  $grid.isotope('layout');
	});

	// -- Relayout and ScrolTto --
	$('details').on('click', '.summary__date', function(){
		var timeoutObj = {
		  current: $(this),
		  func: function(){
	    	$grid.isotope('layout');
				// var headerH = $('.header__navbar').outerHeight();
				// $('html, body').animate({
				// 	scrollTop: this.current.offset().top - headerH - 15
				// }, 'slow');
		  },
		};
		setTimeout(timeoutObj.func.bind(timeoutObj), 0);
	});

	// -- Filter --
	$('.filterByGenre').on('change', function() {
	  // -- Reset no result --
	  $('.noResultsMsg').fadeOut();
	  $('.summary__stage').fadeIn();

	  // -- Open the dates details --
	  $('.section__lineup details:not(.past)').addClass('open').attr('open', true);
	  
		// -- Set filter --
	  var filterValue = this.value;
	  $grid.isotope({ filter: filterValue });

	  $($grid).each(function(index,value) {
	  	var filteredItems = $(this).data('isotope').filteredItems.length;
			if (!filteredItems) {
				// -- Display no results message by stage -- 
		  	// $(this).isotope({ filter: '.noResults' });
				// -- Hide empty stages --
				$(this).prev('.summary__stage').fadeOut();
			}
	  });

	  $('.summary__date + .details__inner').each(function(index,value){
			// -- Handle no results message by date --
	  	setTimeout(function(){
	  		if ($(value).outerHeight() <= 1) {
	  			$(value).find('.noResultsMsg').fadeIn();
	  		}
	  	},1000);
	  });

	  // -- Hide the border on last filtered item --
	  $('.event.grid__item').each(function(index,value){
	  	if ($(this).hasClass(filterValue.replace(/\./,'')) && !$(this).nextAll().hasClass(filterValue.replace(/\./,''))) {
	  		$(this).css({
	  			'border-bottom': 'none'
	  		});
	  	} else if (!$(this).is(':last-of-type')) {
	  		$(this).css({
	  			'border-bottom': '1px solid #afaca1'
	  		});
	  	}
	  });

	});

});